// extracted by mini-css-extract-plugin
export default {"container":"ColorBadge_container__djhdQ","colorTag":"ColorBadge_colorTag__oAydm","withBorder":"ColorBadge_withBorder__fTKKW","label":"ColorBadge_label__GwZF1"};